<div
  #p="ngbPopover"
  popoverClass="my-custom-class"
  (click)="selectPopover(p)"
  [autoClose]="false"
  [ngbPopover]="popContent"
  [popoverTitle]="popTitle"
  placement="bottom-end"
  style="cursor: pointer"
  triggers="manual"
>
  @if (p.isOpen()) {
    @if (isAssignmentAdded()) {
      <img alt="chevron-up" src="assets/bootstrap_icons/chevron-up.svg" />
    } @else {
      <img
        alt="chevron-up"
        src="assets/bootstrap_icons/chevron-up-orange.svg"
      />
    }
  } @else {
    @if (isAssignmentAdded()) {
      <img alt="chevron-down" src="assets/bootstrap_icons/chevron-down.svg" />
    } @else {
      <img
        alt="chevron-down"
        src="assets/bootstrap_icons/chevron-down-orange.svg"
      />
    }
  }
</div>

<ng-template #popTitle>
  <div class="d-flex justify-content-between title gap-3">
    <p>{{ "front.popover-edit.search-people" | translate }}</p>
    <app-icons-image
      class="close-icon"
      name="close"
      (click)="p.close()"
    ></app-icons-image>
  </div>
</ng-template>

<ng-template #popContent>
  <app-input-search (searchChange)="handleSearchChange($event)" />
  <div class="py-1 users-box">
    @for (user of filteredUsers(); track user) {
      <p
        (click)="selectUser(user)"
        class="cursor-pointer user-name"
        [ngClass]="{ selected: isSelected(user.id) }"
      >
        {{ user.name }}
      </p>
    }
  </div>
  <div class="btn-block">
    <cancel-btn (click)="handleCancel()"></cancel-btn>
    <save-btn
      [label]="'front.save-btn.assign'"
      (click)="handleSubmit()"
    ></save-btn>
  </div>
</ng-template>
